// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { filter as FILTER_ENUM } from 'Enum';
import { useLocale } from 'shared_services/redux/hooks/useLocale';
import { UrlAssembler } from 'shared_services/riseart/utils/UrlAssembler';
import { FilterBreadcrumbs } from 'shared_components/common/filters/breadcrumbs/Breadcrumbs';

type Props = {
  id: number,
  name: string,
  alias: string,
  pageLabel: string,
  mediums: Array<string>,
  styles: Array<string>,
  disableArtistLink?: boolean,
};

/**
 * ArtistBreadcrumbs
 *
 * @param {Props} props
 */
export const ArtistBreadcrumbs = ({
  id,
  name,
  alias,
  mediums,
  styles,
  pageLabel,
  disableArtistLink = false,
}: Props) => {
  const locale = useLocale();
  const artistUrl = disableArtistLink ? null : UrlAssembler.artistProfile(id, alias, { locale });

  return (
    <FormattedMessage id={`components.artist.${pageLabel}`}>
      {(pageLabel: string) => (
        <FilterBreadcrumbs
          includePageRootLink={false}
          includeMediumInStyle
          filterDomain={FILTER_ENUM.domain.ARTIST}
          filters={{
            medium: mediums && mediums[0] ? [mediums[0]] : null,
            style: styles && styles[0] ? [styles[0]] : null,
          }}
          config={['medium', 'style']}
          additionalLinks={[
            {
              isLink: !!artistUrl,
              name,
              url: artistUrl,
            },
            {
              isLink: false,
              name: pageLabel,
            },
          ]}
        />
      )}
    </FormattedMessage>
  );
};
